import { render, staticRenderFns } from "./AkademieAdmin.vue?vue&type=template&id=540e8f3d&scoped=true"
import script from "./AkademieAdmin.vue?vue&type=script&lang=js"
export * from "./AkademieAdmin.vue?vue&type=script&lang=js"
import style0 from "./AkademieAdmin.vue?vue&type=style&index=0&id=540e8f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e8f3d",
  null
  
)

export default component.exports